var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModify(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.276,
    height: 11.269,
    viewBox: "0 0 11.276 11.269",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_77200",
    "data-name": "Group 77200",
    transform: "translate(18293.307 -7537.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M8.961,4.186,8.652,5.6a.393.393,0,0,0,.106.361.407.407,0,0,0,.361.106l1.413-.31a.392.392,0,0,0,.194-.106L14.3,2.077a1.178,1.178,0,0,0,0-1.665,1.2,1.2,0,0,0-1.663,0L9.069,3.992A.393.393,0,0,0,8.961,4.186ZM13.19.968a.4.4,0,0,1,.554,0,.4.4,0,0,1,0,.555l-.277.277-.554-.555ZM9.7,4.466,12.357,1.8l.549.552L10.249,5.019l-.7.155Z",
    transform: "translate(-18296.852 7537.791)",
    stroke: "#000",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    d: "M1.581,11.95H8.359A1.587,1.587,0,0,0,9.94,10.361V6.952a.452.452,0,1,0-.9,0v3.409a.682.682,0,0,1-.678.684H1.581A.682.682,0,0,1,.9,10.361V3.589A.682.682,0,0,1,1.581,2.9H4.97a.452.452,0,0,0,0-.9H1.581A1.587,1.587,0,0,0,0,3.589v6.772A1.587,1.587,0,0,0,1.581,11.95Z",
    transform: "translate(-18293.207 7536.92)",
    stroke: "#000",
    strokeWidth: 0.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModify);
export default __webpack_public_path__ + "static/media/Modify.1ecd4b66eacf2ee448157bf1c29c8fdb.svg";
export { ForwardRef as ReactComponent };